import { render, staticRenderFns } from "./ObjekPajakNop.vue?vue&type=template&id=ac2d0ddc&scoped=true&"
import script from "./ObjekPajakNop.vue?vue&type=script&lang=js&"
export * from "./ObjekPajakNop.vue?vue&type=script&lang=js&"
import style0 from "./ObjekPajakNop.vue?vue&type=style&index=0&id=ac2d0ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2d0ddc",
  null
  
)

export default component.exports